import { useMemo } from 'react';

import type { UpdateTaskItemAttrs } from '../taskItemChipsUtils';
import type { ElementChipCallbackSet } from './useElementChipCallbacks';

/**
 * Due-date callbacks for task-item chips. Mutates the owning task node's attrs
 * via `updateAttributes` instead of dispatching element-keyed redux actions.
 */
export const useDueDateTaskItemChipCallbacks = ({
    updateAttributes,
    canModifyDueDate,
}: {
    updateAttributes: UpdateTaskItemAttrs;
    canModifyDueDate: boolean;
}): ElementChipCallbackSet =>
    useMemo(
        () => (chip) => {
            if (chip.type !== 'due-date') return {};

            return {
                canModify: canModifyDueDate,
                onDeleteKeyDown: (event) => {
                    if (!canModifyDueDate) return;

                    event.preventDefault();
                    event.stopPropagation();
                    updateAttributes({ dueDate: null });
                },
            };
        },
        [canModifyDueDate, updateAttributes],
    );
